import type { AvatarConfig, DirectMessagePayload } from '@shared/index'
import { api } from './http'

export type FriendPresence = 'offline' | 'online' | 'in_duel'

export type FriendPerson = {
  username: string
  avatar: AvatarConfig
}

export type FriendEntry = FriendPerson & {
  presence: FriendPresence
  unread: number
}

export type FriendsSnapshot = {
  friends: FriendEntry[]
  incoming: FriendPerson[]
  outgoing: FriendPerson[]
}

export type FriendChange = {
  username: string
  status: 'pending' | 'accepted' | 'declined' | 'cancelled' | 'removed'
  changed: boolean
}

export function fetchFriends(token: string): Promise<FriendsSnapshot> {
  return api<FriendsSnapshot>('/friends', { token, quiet: true })
}

export function requestFriend(token: string, username: string): Promise<FriendChange> {
  return api<FriendChange>('/friends', {
    token,
    method: 'POST',
    body: JSON.stringify({ username }),
  })
}

export function acceptFriend(token: string, username: string): Promise<FriendChange> {
  return api<FriendChange>('/friends/accept', {
    token,
    method: 'POST',
    body: JSON.stringify({ username }),
  })
}

export function declineFriend(token: string, username: string): Promise<FriendChange> {
  return api<FriendChange>('/friends/decline', {
    token,
    method: 'POST',
    body: JSON.stringify({ username }),
  })
}

export function cancelFriend(token: string, username: string): Promise<FriendChange> {
  return api<FriendChange>('/friends/cancel', {
    token,
    method: 'POST',
    body: JSON.stringify({ username }),
  })
}

export function removeFriend(token: string, username: string): Promise<FriendChange> {
  return api<FriendChange>('/friends/remove', {
    token,
    method: 'POST',
    body: JSON.stringify({ username }),
  })
}

export function fetchDirect(
  token: string,
  username: string,
): Promise<{ messages: DirectMessagePayload[] }> {
  return api<{ messages: DirectMessagePayload[] }>(
    `/friends/dm/${encodeURIComponent(username)}`,
    { token, quiet: true },
  )
}

export function markDirectRead(token: string, username: string): Promise<{ unread: number }> {
  return api<{ unread: number }>(`/friends/dm/${encodeURIComponent(username)}/read`, {
    token,
    method: 'POST',
    quiet: true,
  })
}
